const environment = {
  production: true,
  apiUrl: "http://api.playit.mobi/api/v2",
  apiKey: ""
};
export default environment;
